<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
</template>
